import React from "react";

export default function SimplePersonSilhouette({
  className,
  title = "Camera Off",
}) {
  return (
    <svg
      viewBox="0 0 64 64"
      className={className}
      role="img"
      aria-label={title}
      preserveAspectRatio="xMidYMid meet"
    >
      <title>{title}</title>

      <g fill="currentColor">
        {/* Head */}
        <circle cx="32" cy="14" r="8" />

        {/* Torso */}
        <rect x="22" y="24" width="20" height="24" rx="4" />

        {/* Left arm (45° up) */}
        <rect
          x="6"
          y="24"
          width="18"
          height="6"
          rx="3"
          transform="rotate(60 24 24)"
        />

        {/* Right arm (45° up) */}
        <rect
          x="40"
          y="24"
          width="18"
          height="6"
          rx="3"
          transform="rotate(-60 40 24)"
        />
      </g>
    </svg>
  );
}
